import type {
  GetAccountBonusesResponse,
  DailyBonusInfo,
  InvitationBonusInfo,
} from '@patrianna/shared-patrianna-types/store/AccountBonusesModule'
import type { BaseBonus, InvitationBonus } from '@patrianna/shared-patrianna-types/store/BonusesFlowModule'
import { createSlice } from '@reduxjs/toolkit'
import type { PayloadAction } from '@reduxjs/toolkit'

import type { BonusesFlowState, WheelFreeSpinsClaimState } from './types'
import { getActiveBonuses } from './utils'

export type GetAccountBonusesResponseExt = GetAccountBonusesResponse & { wheels: BonusesFlowState['wheels'] } // TODO: temp

const initialState: BonusesFlowState = {
  dailyBonuses: null,
  manualBonuses: null,
  delayedBonuses: null,
  invitationBonuses: null,
  wheels: null,
  wheelSpinning: false,
  loading: false,
  loaded: false,
  isRewardDialogShown: false,
  wheelFreeSpinsClaimState: 'inactive',
  accepting: false,
}

export const bonusesFlowSlice = createSlice({
  name: 'bonusesFlow',
  initialState,
  reducers: {
    // @TODO will remove?
    saveDailyBonuses: (state, action: PayloadAction<{ dailyBonuses: DailyBonusInfo[] }>) => {
      const bonuses = getActiveBonuses(action.payload.dailyBonuses)
      state.dailyBonuses = bonuses
    },

    saveManualBonuses: (state, action: PayloadAction<{ manualBonuses: BaseBonus[] }>) => {
      state.manualBonuses = action.payload.manualBonuses
    },

    saveInvitatonBonuses: (
      state,
      action: PayloadAction<{ invitationBonuses: (InvitationBonus | InvitationBonusInfo)[] }>,
    ) => {
      state.invitationBonuses = action.payload.invitationBonuses
    },

    saveDelayedBonuses: (state, action: PayloadAction<{ delayedBonuses: BaseBonus[] }>) => {
      state.delayedBonuses = action.payload.delayedBonuses
    },

    saveWheels: (state, action: PayloadAction<BonusesFlowState['wheels']>) => {
      state.wheels = action.payload
    },

    setWheelSpinning: (state, action: PayloadAction<BonusesFlowState['wheelSpinning']>) => {
      state.wheelSpinning = action.payload
    },

    receivedBonuses: (state, action: PayloadAction<{ body: GetAccountBonusesResponseExt }>) => {
      const { manual, daily, invitation, wheels } = action.payload.body
      state.manualBonuses = manual
      state.dailyBonuses = daily
      state.invitationBonuses = invitation
      state.wheels = wheels
    },

    setBonusesLoading: (state, action: PayloadAction<boolean>) => {
      state.loading = action.payload
    },

    setBonusesLoaded: (state, action: PayloadAction<boolean>) => {
      state.loaded = action.payload
    },

    setIsRewardDialogShown: (state) => {
      state.isRewardDialogShown = true
    },

    setWheelFreeSpinsClaimState: (state, action: PayloadAction<WheelFreeSpinsClaimState>) => {
      state.wheelFreeSpinsClaimState = action.payload
    },

    setAcceptingDailyBonus: (state, action: PayloadAction<{ accepting: boolean }>) => {
      state.accepting = action.payload.accepting
    },
  },
})

export type ActionsTypes = ReturnType<InferValueTypes<typeof bonusesFlowSlice.actions>>
export const { actions } = bonusesFlowSlice
